import { PhilatelicItemType, type PhilatelicItem, type ReviewState } from '@briefmarken_katalog/types';

export interface SearchFilter {
  enabled: boolean;
  dateFrom: string;        // 'YYYY-MM-DD' or ''
  dateTo: string;          // 'YYYY-MM-DD' or ''
  ownOnly: boolean;
  reviewedByMe: boolean;
  descriptionWords: string;
  zhihao: string;
  itemTypes: PhilatelicItemType[];
  reviewStates: ReviewState[];
}

export function defaultSearchFilter(): SearchFilter {
  return {
    enabled: false,
    dateFrom: '',
    dateTo: '',
    ownOnly: false,
    reviewedByMe: false,
    descriptionWords: '',
    zhihao: '',
    itemTypes: [],
    reviewStates: [],
  };
}

export function applyFilter(
  items: PhilatelicItem[],
  filter: SearchFilter,
  currentUserId: string | null
): PhilatelicItem[] {
  if (!filter.enabled) return items;

  return items.filter(item => {
    if (filter.dateFrom) {
      const from = new Date(filter.dateFrom);
      if (new Date(item.date_of_issue) < from) return false;
    }
    if (filter.dateTo) {
      const to = new Date(filter.dateTo);
      to.setHours(23, 59, 59, 999);
      if (new Date(item.date_of_issue) > to) return false;
    }
    if (filter.ownOnly && currentUserId) {
      if (item.review.suggestedBy !== currentUserId) return false;
    }
    if (filter.reviewedByMe && currentUserId) {
      if (item.review.reviewedBy !== currentUserId) return false;
    }
    if (filter.descriptionWords.trim()) {
      const words = filter.descriptionWords.trim().toLowerCase().split(/\s+/);
      const desc = item.description.toLowerCase();
      if (!words.every(w => desc.includes(w))) return false;
    }
    if (filter.zhihao.trim()) {
      const needle = filter.zhihao.trim().toLowerCase();
      const haystack = (item.zhihao?.raw ?? '').toLowerCase();
      if (!haystack.includes(needle)) return false;
    }
    if (filter.itemTypes.length > 0) {
      if (!filter.itemTypes.includes(item.type as PhilatelicItemType)) return false;
    }
    if (filter.reviewStates.length > 0) {
      if (!filter.reviewStates.includes(item.review.state)) return false;
    }
    return true;
  });
}
